import { useState, useEffect, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { formatNumber } from '../../utils/generalFunctions';

import { buscarDashboard } from '../../actions/dashboard';

const DashboardAdministrador = () => {

    const dispatch =  useDispatch();

    const { detalles } = useSelector(state => state.dashboard);
    const { usuario } = useSelector(state => state.auth);

    const [dashboardData, setDashboardData] = useState({
        administradores: null, 
        asistentes: null, 
        locatarios: null, 
        clientes: null, 
        citas_totales: null, 
        citas_pendientes: null, 
        citas_finalizadas: null, 
        citas_canceladas: null, 
        locatario_citas: null, 
        locatario_paquetes: null, 
        membresia_mas: null, 
        membresia_menos: null, 
        cliente_citas: null, 
        cliente_membresias: null, 
        cliente_paquetes: null, 
        paquete_mas: null, 
        paquete_menos: null
    });

    useEffect(() => {
        dispatch(buscarDashboard('administrador'));
    }, []);

    useEffect(() => {
        if(detalles){
            setDashboardData({
                ...dashboardData, 
                administradores: detalles.usuarios?.administradores, 
                asistentes: detalles.usuarios?.asistentes, 
                locatarios: detalles.usuarios?.locatarios, 
                clientes: detalles.clientes?.totales, 
                citas_totales: detalles.citas?.totales, 
                citas_pendientes: detalles.citas?.pendientes, 
                citas_finalizadas: detalles.citas?.finalizadas, 
                citas_canceladas: detalles.citas?.canceladas, 
                locatario_citas: detalles.locatario?.con_mas_citas ? (detalles.locatario?.con_mas_citas?.servicio?.nombre + ' (' + detalles.locatario?.con_mas_citas?.nombre + ')') : null, 
                locatario_paquetes: detalles.locatario?.con_mas_paquetes_vendidos ? (detalles.locatario?.con_mas_paquetes_vendidos?.servicio?.nombre + ' (' + detalles.locatario?.con_mas_paquetes_vendidos?.nombre + ')') : null, 
                membresia_mas: detalles.membresia?.mas_adquirida ? detalles.membresia?.mas_adquirida?.nombre : null, 
                membresia_menos: detalles.membresia?.menos_adquirida ? detalles.membresia?.menos_adquirida?.nombre : null, 
                cliente_citas: detalles.cliente?.con_mas_citas ? ([detalles.cliente?.con_mas_citas?.nombre, detalles.cliente?.con_mas_citas?.apellido_paterno, detalles.cliente?.con_mas_citas?.apellido_materno].join(' ')) : null, 
                cliente_membresias: detalles.cliente?.con_mas_membresias ? ([detalles.cliente?.con_mas_membresias?.nombre, detalles.cliente?.con_mas_membresias?.apellido_paterno, detalles.cliente?.con_mas_membresias?.apellido_materno].join(' ')) : null, 
                cliente_paquetes: detalles.cliente?.con_mas_paquetes ? ([detalles.cliente?.con_mas_paquetes?.nombre, detalles.cliente?.con_mas_paquetes?.apellido_paterno, detalles.cliente?.con_mas_paquetes?.apellido_materno].join(' ')) : null, 
                paquete_mas: detalles.paquete?.mas_adquirido ? detalles.paquete?.mas_adquirido?.nombre : null, 
                paquete_menos: detalles.paquete?.menos_adquirido ? detalles.paquete?.menos_adquirido?.nombre : null
            });
        }        
    }, [detalles]);

    return (
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        .imagen_perfil {
                            height: 100px;
                            width: 100px;
                            border-radius: 50%;
                            border: 2px solid #111f62;
                            margin-right: 15px;
                        }

                        .titulo {
                            color: #111f62;
                        }

                        .indicador {
                            font-size: 18px;
                            margin: 0;
                        }

                        .subtitulo {
                            margin: 0;
                            font-weight: 700;
                        }
                    `}</style>
                </Helmet>
            </HelmetProvider>
        
            <div className="col-md-12 d-flex align-items-center mb-2">
                <img className="imagen_perfil" src={usuario.url_perfil_g != null ? usuario.url_perfil_g : process.env.REACT_APP_PUBLIC_ROUTE + '/assets/images/perfil_placeholder.png'}/>
                <h4 className="titulo">
                    ¡Hola {[usuario.nombre, usuario.apellido_paterno, usuario.apellido_materno].join(' ')}!
                </h4>
            </div>

            <div className="col-md-5 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Usuarios</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.administradores != null && dashboardData.administradores != undefined ? formatNumber(dashboardData.administradores, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">administradores</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.asistentes != null && dashboardData.asistentes != undefined ? formatNumber(dashboardData.asistentes, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">asistentes</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.locatarios != null && dashboardData.locatarios != undefined ? formatNumber(dashboardData.locatarios, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">locatarios</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-2 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Clientes</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.clientes != null && dashboardData.clientes != undefined ? formatNumber(dashboardData.clientes, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">totales</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-5 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Citas</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.citas_totales != null && dashboardData.citas_totales != undefined ? formatNumber(dashboardData.citas_totales, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">totales</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.citas_pendientes != null && dashboardData.citas_pendientes != undefined ? formatNumber(dashboardData.citas_pendientes, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">pendientes</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.citas_finalizadas != null && dashboardData.citas_finalizadas != undefined ? formatNumber(dashboardData.citas_finalizadas, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">finalizadas</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.citas_canceladas != null && dashboardData.citas_canceladas != undefined ? formatNumber(dashboardData.citas_canceladas, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">canceladas</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-8 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Locatario</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.locatario_citas != null && dashboardData.locatario_citas != undefined ? dashboardData.locatario_citas : 'Sin definir'}</p>
                                <p className="subtitulo">con más citas</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.locatario_paquetes != null && dashboardData.locatario_paquetes != undefined ? dashboardData.locatario_paquetes : 'Sin definir'}</p>
                                <p className="subtitulo">con más paquetes vendidos</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-4 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Membresía</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.membresia_mas != null && dashboardData.membresia_mas != undefined ? dashboardData.membresia_mas : 'Sin definir'}</p>
                                <p className="subtitulo">más adquirida</p>
                            </div>

                            <div className="col">
                                <p className="indicador">{dashboardData.membresia_menos != null && dashboardData.membresia_menos != undefined ? dashboardData.membresia_menos : 'Sin definir'}</p>
                                <p className="subtitulo">menos adquirida</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-8 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Cliente</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.cliente_citas != null && dashboardData.cliente_citas != undefined ? dashboardData.cliente_citas : 'Sin definir'}</p>
                                <p className="subtitulo">con más citas</p>
                            </div>

                            <div className="col">
                                <p className="indicador">{dashboardData.cliente_membresias != null && dashboardData.cliente_membresias != undefined ? dashboardData.cliente_membresias : 'Sin definir'}</p>
                                <p className="subtitulo">con más membresias</p>
                            </div>

                            <div className="col">
                                <p className="indicador">{dashboardData.cliente_paquetes != null && dashboardData.cliente_paquetes != undefined ? dashboardData.cliente_paquetes : 'Sin definir'}</p>
                                <p className="subtitulo">con más paquetes</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-4 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Paquete</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.paquete_mas != null && dashboardData.paquete_mas != undefined ? dashboardData.paquete_mas : 'Sin definir'}</p>
                                <p className="subtitulo">más adquirido</p>
                            </div>

                            <div className="col">
                                <p className="indicador">{dashboardData.paquete_menos != null && dashboardData.paquete_menos != undefined ? dashboardData.paquete_menos : 'Sin definir'}</p>
                                <p className="subtitulo">menos adquirido</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default DashboardAdministrador;